<template>
  <main>
    <section class="ads-hero">
      <div class="container">
        <div class="ads-hero-inner">
          <div class="ads-hero-content">
            <h1 class="ads-hero-title">
              E-Ticaret Reklamlarınızı<br />
              <span class="highlight">Otomatik Yönetin,</span><br />
              Satışlarınızı Büyütün!
            </h1>

            <div class="ads-hero-offer">
              <span class="offer-label">İlk bakiye yüklemenize özel olarak</span>
              <span class="offer-amount">24.000 ₺ <span>Reklam Desteği</span></span>
            </div>

            <ul class="ads-hero-features">
              <li>
                <svg class="check-icon" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="10" fill="#235dff" opacity="0.12"/>
                  <path d="M6 10.5l2.5 2.5 5.5-5.5" stroke="#235dff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Reklam kurulumu ve yönetimi otomatik
              </li>
              <li>
                <svg class="check-icon" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="10" fill="#235dff" opacity="0.12"/>
                  <path d="M6 10.5l2.5 2.5 5.5-5.5" stroke="#235dff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Yapay zeka destekli optimizasyon
              </li>
              <li>
                <svg class="check-icon" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="10" fill="#235dff" opacity="0.12"/>
                  <path d="M6 10.5l2.5 2.5 5.5-5.5" stroke="#235dff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Daha düşük maliyetle daha yüksek dönüşüm
              </li>
            </ul>

            <div class="ads-hero-cta">
              <button @click="scrollToBottom" class="bttn primary radiused cta-button">Reklam Hesabını Kur</button>
              <span class="cta-note">Kurulum ücreti yok.</span>
            </div>
          </div>

          <div class="ads-hero-visual">
            <img :src="bannerImage" alt="Kobisi Ads" />
          </div>
        </div>
      </div>
    </section>
    <!-- Nasıl Çalışır Alanı -->
    <section class="how-it-works">
      <div class="container">
        <div class="section-title text-center">
          <span class="pre-title">NASIL ÇALIŞIR?</span>
          <h2>4 Adımda Reklamlarınız Otomatik Olarak Büyüsün</h2>
        </div>
        
        <div class="cards-grid">
          <!-- Step 1 -->
          <div class="step-card">
            <div class="icon-box">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
            </div>
            <h3>1. Mağazanızı Bağlayın</h3>
            <p>Google Ads ve Merchant Center hesaplarınızı saniyeler içinde kurun. Dönüşüm takip kodları otomatik olarak eklenir ve kampanyalarınızın performansını kolayca takip edebilirsiniz.</p>
          </div>
          
          <!-- Step 2 -->
          <div class="step-card">
            <div class="icon-box">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
              </svg>
            </div>
            <h3>2. Ürünleriniz Otomatik Aktarılsın</h3>
            <p>Ürünlerinizi Google Merchant Center’a hızlı ve kolay bir şekilde aktararak hedef kitlenize etkili bir şekilde ulaşın. Tüm işlemler, Kobisi Max Performans Reklam’ın akıllı sistemi ile sorunsuz bir şekilde gerçekleşir.</p>
          </div>
          
          <!-- Step 3 -->
          <div class="step-card">
            <div class="icon-box">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
              </svg>
            </div>
            <h3>3. Kampanyalar Oluşturulsun</h3>
            <p>Kobisi Max Performans Reklam, reklamlarınızı gerçek zamanlı verilere dayanarak optimize eder ve satış performansınızı maksimize eder. Daha düşük bütçelerle daha yüksek dönüşümler elde edin!</p>
          </div>
          
          <!-- Step 4 -->
          <div class="step-card">
            <div class="icon-box">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                <polyline points="17 6 23 6 23 12"></polyline>
              </svg>
            </div>
            <h3>4. Satışlarınızı Optimize Edelim</h3>
            <p>Kobisi Max Performans Reklam, reklamlarınızın satış, tıklama ve görüntülenme performansını detaylı raporlar halinde sunar. Bu sayede stratejinizi geliştirmek için gerekli tüm verilere anında erişebilirsiniz.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Referanslar Alanı -->
    <section class="testimonials">
      <div class="container">
        <div class="section-title text-center">
          <h2>Kobisi ile kazananlar neler söylüyor</h2>
          <p>E-ticarete başlamak için Kobisi'yi tercih eden müşterilerimiz kullanıcı deneyimlerini bizlerle paylaştılar.</p>
        </div>
        
        <div class="testimonial-card">
          <div class="testimonial-content">
            <!-- Sol Taraf: Yazılar -->
            <div class="text-area">
              <h3>basakdolabi.com</h3>
              <h4 class="highlight">Kobisi Max. Performans ile Kişiye Özel Takı Tasarım Kategorisinde Fark Yaratan Kampanyalar!</h4>
              <p>
                <strong>basakdolabi.com</strong>; kişiye özel takı tasarımı, anahtarlık ve portre tasarımındaki özgün duruşunu Kobisi Max. Performans’ın akıllı hedefleme ve otomasyon gücüyle birleştirerek rekabette öne geçti. Duygulara hitap eden özel tasarım ürünlerini, tam da bu ürünleri arayan doğru kitlelerle buluşturan stratejik kampanya kurguları sayesinde hem marka bilinirliğini artırdı hem de dönüşüm oranlarını zirveye taşıdı. Gerçek zamanlı optimizasyon ve veriye dayalı bütçe yönetimi ile reklam yatırımlarını en yüksek verimle kullanan <strong>basakdolabi.com</strong>, kişiselleştirilmiş takı ve anahtarlık segmentinde güçlü bir marka algısı oluşturarak sürdürülebilir bir büyüme ivmesi yakaladı.
              </p>
            </div>
            
            <!-- Sağ Taraf: Video -->
            <div class="video-area">
              <video :src="testimonialVideo" autoplay loop muted playsinline class="testimonial-video"></video>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Problemi Çözüyoruz Alanı -->
    <section class="problem-solution">
      <div class="container">
        <div class="problem-card">
          <div class="problem-visual">
            <div class="laptop-mockup">
              <div class="laptop-body">
                <div class="laptop-screen">
                  <div class="screen-header">
                    <div class="dot" style="background-color: #ff5f56;"></div>
                    <div class="dot" style="background-color: #ffbd2e;"></div>
                    <div class="dot" style="background-color: #27c93f;"></div>
                  </div>
                  <div class="screen-content">
                    <div class="chart-left">
                      <div class="pie-chart"></div>
                      <div class="lines">
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                      </div>
                    </div>
                    <div class="chart-right">
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Tooltips -->
              <div class="floating-box floating-box-1">
                <div class="icon-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
                </div>
                <span>Boşa Harcanan<br>Bütçe</span>
              </div>
              
              <div class="floating-box floating-box-2">
                <div class="icon-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
                </div>
                <span>Yanlış Hedefleme</span>
              </div>
              
              <div class="floating-box floating-box-3">
                <div class="icon-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
                </div>
                <span>Düşük Dönüşüm</span>
              </div>
            </div>
            
            <div class="floating-boxes-mobile">
              <div class="floating-box floating-box-mobile">
                <div class="icon-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
                </div>
                <span>Boşa Harcanan Bütçe</span>
              </div>
              <div class="floating-box floating-box-mobile">
                <div class="icon-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
                </div>
                <span>Yanlış Hedefleme</span>
              </div>
              <div class="floating-box floating-box-mobile">
                <div class="icon-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
                </div>
                <span>Düşük Dönüşüm</span>
              </div>
            </div>
          </div>
          
          <div class="problem-content">
            <span class="pre-title">PROBLEMİ ÇÖZÜYORUZ</span>
            <h2>Reklam Bütçeniz<br/><span class="highlight-orange">Boşa Gitmesin!</span></h2>
            <p class="desc-1">E-ticarette reklam bütçelerinin büyük kısmı yanlış hedefleme ve eksik optimizasyon nedeniyle verimsiz kullanılıyor.</p>
            <p class="desc-2">Kobisi Ads, kampanyalarınızı sürekli optimize ederek daha düşük maliyetle daha yüksek dönüşüm elde etmenize yardımcı olur.</p>
          </div>
        </div>
      </div>
    </section>
    <!-- CTA Banner Alanı -->
    <section class="cta-banner">
      <div class="container">
        <div class="cta-banner-inner">
          <div class="cta-left">
            <h2>Hemen Kobisi Max Performans Reklam olun, yeni gelir kaynağınızı bugün oluşturun!</h2>
            <ul class="features">
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                Hızlı Başvuru
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                Ücretsiz
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                Taahhüt Yok
              </li>
            </ul>
          </div>
          
          <div class="cta-middle">
            <div class="gift-badge-container">
              <div class="gift-illustration">
                <img :src="giftImage" alt="Hediye" class="gift-img">
              </div>
              <div class="gift-text">
                <span class="amount">24.000 TL</span>
                <span class="desc">Reklam Desteği</span>
              </div>
            </div>
          </div>
          
          <div class="cta-right">
            <h3>Kobisi Max Performans Reklam Başvurusu Yapın</h3>
            <div v-if="show" class="alert" :class="alertClasses" role="alert" v-html="message" style="margin-bottom: 1em; padding: 1em; border-radius: 8px; font-size: 0.9em; line-height: 1.4;"></div>
            <form @submit.prevent="submitForm" id="adsForm" action="https://admin.kobisi.com/home/createAdsApplication" method="POST" class="cta-form">
              <div class="form-row">
                <input type="text" v-model="form.name" :class="{ error: errors.name }" name="name" placeholder="İsim Soyisim">
                <input type="tel" v-model="form.phone" :class="{ error: errors.phone }" name="phone" placeholder="Telefon Numarası">
              </div>
              <div class="form-row">
                <input type="email" v-model="form.email" :class="{ error: errors.email }" name="email" placeholder="E-posta Adresi">
              </div>
              <div class="form-row">
                <input type="text" v-model="form.site" :class="{ error: errors.site }" name="site" placeholder="Site İsminiz">
              </div>
              <button type="submit" class="submit-btn">
                Başvuruyu Gönder &rarr;
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

  </main>
</template>

<script>
import tr from "@/lang/tr.js";
import en from "@/lang/en.js";
import bannerImg from "@/assets/images/ads/banner.png";
import basakVideo from "@/assets/basakdolabi.mp4";
import giftImg from "@/assets/gift.png";

export default {
  mixins: [tr, en],
  name: "KobisiAdsView",
  components: {
  },
  props: {
    lang: String,
  },
  data() {
    return {
      bannerImage: bannerImg,
      testimonialVideo: basakVideo,
      giftImage: giftImg,
      form: {
        name: "",
        phone: "",
        email: "",
        site: "",
      },
      show: false,
      alertClasses: "alert alert-success",
      message: "",
      errors: {},
    };
  },
  methods: {
    submitForm() {
      this.errors = {};

      if (!this.form.name) this.errors.name = true;
      if (!this.form.phone) this.errors.phone = true;
      if (!this.form.email) this.errors.email = true;
      if (!this.form.site) this.errors.site = true;

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      document.getElementById("adsForm").submit();
    },
    scrollToBottom() {
      setTimeout(() => {
        const ctaSection = document.querySelector(".cta-banner");
        if (ctaSection) {
          ctaSection.scrollIntoView({ behavior: "smooth" });
        } else {
          window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 50);
    },
  },
  beforeMount() {
    if (this.$route.query.success) {
      this.scrollToBottom();
      this.show = true;
      this.alertClasses = "alert alert-success";
      this.message =
        "Başvurunuz alınmıştır. En kısa sürede sizinle iletişime geçilecektir.";
    }

    if (this.$route.query.error) {
      this.scrollToBottom();
      this.show = true;
      this.alertClasses = "alert alert-danger";

      if (this.$route.query.error === "already-form") {
        this.message =
          'Yakın zamanda kayıt yaptırdınız. Lütfen daha sonra tekrar deneyin.<br>Eğer bu bir hata ise, <a href="mailto:kobisiekip@imovasyon.com">kobisiekip@imovasyon.com</a> adresine e-posta gönderin.';
      } else if (this.$route.query.error === "already-register") {
        this.message =
          'Bu bilgiler zaten kayıtlı.<br> Eğer bu bir hata ise, <a href="mailto:kobisiekip@imovasyon.com">kobisiekip@imovasyon.com</a> adresine e-posta gönderin.';
      } else if (this.$route.query.error === "not-register") {
        this.message =
          'Kayıt olurken bir hata oluştu. Lütfen tekrar deneyin ya da, <a href="mailto:kobisiekip@imovasyon.com">kobisiekip@imovasyon.com</a> adresine e-posta gönderin.';
      } else {
        this.message = "Bir hata oluştu. Lütfen tekrar deneyin.";
      }
    }
  },
  metaInfo() {
    return {
      title: "Kobisi Ads - E-Ticaret Reklamlarınızı Otomatik Yönetin",
      meta: [
        {
          name: "description",
          content:
            "Kobisi Ads ile e-ticaret reklamlarınızı otomatik yönetin, yapay zeka destekli optimizasyon ile satışlarınızı büyütün.",
        },
      ],
    };
  },
  mounted() {
    document.body.classList.add("kobisi-ads", "active-page");
  },
  destroyed() {
    document.body.classList.remove("kobisi-ads", "active-page");
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.ads-hero {
  padding-top: 10em;
  padding-bottom: 4em;
  background-color: $gray;
  min-height: 80vh;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  
  @media screen and (max-width: 768px) {
    padding-top: 12em;
    padding-bottom: 2em;
    min-height: auto;
  }

  &::before {
    content: "";
    position: absolute;
    top: -120px;
    right: -120px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba($primary-color, 0.06) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -80px;
    left: -80px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba($primary-color, 0.04) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
  }
}

.ads-hero-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3em;

  @media screen and (max-width: 992px) {
    flex-direction: column;
    text-align: center;
  }
}

.ads-hero-content {
  flex: 1;
  max-width: 560px;
  padding-left: 3em;

  @media screen and (max-width: 992px) {
    max-width: 100%;
    order: 2;
    padding-left: 0;
  }
}

.ads-hero-title {
  font-size: 2.6em;
  font-weight: 800;
  line-height: 1.25;
  color: $text-color;
  margin-bottom: 0.7em;

  .highlight {
    color: $primary-color;
    position: relative;
  }

  @media screen and (max-width: 768px) {
    font-size: 1.8em;
  }
}

.ads-hero-offer {
  background: linear-gradient(135deg, rgba($primary-color, 0.07) 0%, rgba($primary-color, 0.03) 100%);
  border: 1px solid rgba($primary-color, 0.15);
  border-radius: 1em;
  padding: 1.2em 1.5em;
  margin-bottom: 1.8em;
  display: flex;
  flex-direction: column;
  gap: 0.3em;

  .offer-label {
    font-size: 0.95em;
    color: lighten($text-color, 15%);
  }

  .offer-amount {
    font-size: 1.8em;
    font-weight: 800;
    color: $primary-color;
    line-height: 1.2;

    span {
      font-weight: 600;
      font-size: 0.65em;
      color: $text-color;
    }
  }

  @media screen and (max-width: 768px) {
    .offer-amount {
      font-size: 1.5em;
    }
  }
}

.ads-hero-features {
  list-style: none;
  padding: 0;
  margin: 0 0 2em 0;
  display: flex;
  flex-direction: column;
  gap: 0.85em;

  li {
    display: flex;
    align-items: center;
    gap: 0.7em;
    font-size: 1.05em;
    color: $text-color;
    font-weight: 500;

    @media screen and (max-width: 992px) {
      justify-content: center;
    }
  }

  .check-icon {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }
}

.ads-hero-cta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.6em;

  @media screen and (max-width: 992px) {
    align-items: center;
  }

  .cta-button {
    padding: 0.9em 2.5em;
    font-size: 1.15em;
    font-weight: 700;
    border: none;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 4px 20px rgba($primary-color, 0.3);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 30px rgba($primary-color, 0.4);
    }
  }

  .cta-note {
    font-size: 0.85em;
    color: lighten($text-color, 25%);
    font-weight: 500;
  }
}

.ads-hero-visual {
  flex: 1.3;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media screen and (max-width: 992px) {
    order: 1;
    max-width: 100%;
    margin-bottom: 3.5em;
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 1em;
    position: relative;
    z-index: 1;
    transform: scale(1.35);
    transform-origin: center;
    
    @media screen and (max-width: 992px) {
      transform: scale(1.3);
    }
  }
}

.problem-solution {
  padding: 4em 0;
  background-color: $white;
  
  @media screen and (max-width: 768px) {
    padding: 2.5em 0;
  }

  .problem-card {
    background-color: #FFF9F6;
    border-radius: 2em;
    padding: 4em;
    display: flex;
    align-items: center;
    gap: 4em;
    
    @media screen and (max-width: 992px) {
      flex-direction: column;
      padding: 2.5em;
    }
    
    @media screen and (max-width: 768px) {
      padding: 1.5em;
      gap: 2em;
    }
  }

  .problem-visual {
    flex: 1;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .laptop-mockup {
    position: relative;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    
    @media screen and (max-width: 768px) {
      margin-bottom: 2em;
      max-width: 320px;
    }
    
    .laptop-body {
      width: 100%;
      height: 260px;
      background-color: #334155;
      border-radius: 16px 16px 0 0;
      padding: 12px;
      position: relative;
      box-shadow: 0 20px 40px rgba(0,0,0,0.08);
      
      @media screen and (max-width: 768px) {
        height: 200px;
        padding: 8px;
      }
      
      &::after {
        content: "";
        position: absolute;
        bottom: -20px;
        left: -5%;
        width: 110%;
        height: 20px;
        background-color: #cbd5e1;
        border-radius: 0 0 20px 20px;
      }
    }
    
    .laptop-screen {
      width: 100%;
      height: 100%;
      background-color: #f8fafc;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      
      .screen-header {
        height: 30px;
        background-color: #fff;
        border-bottom: 1px solid #f1f5f9;
        display: flex;
        align-items: center;
        padding: 0 12px;
        gap: 6px;
        
        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }
      }
      
      .screen-content {
        flex: 1;
        padding: 15px;
        display: flex;
        gap: 15px;
        
        .chart-left {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 15px;
          
          .pie-chart {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            background: conic-gradient(#ff5a36 0% 60%, #3b82f6 60% 85%, #fbbf24 85% 100%);
            margin: 0 auto;
          }
          
          .lines {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 0 5px;
            .line {
              height: 5px;
              background-color: #e2e8f0;
              border-radius: 3px;
              
              &:nth-child(1) { width: 100%; }
              &:nth-child(2) { width: 80%; }
              &:nth-child(3) { width: 60%; }
            }
          }
        }
        
        .chart-right {
          flex: 1.5;
          display: flex;
          align-items: flex-end;
          gap: 6px;
          border-bottom: 2px solid #e2e8f0;
          padding-bottom: 5px;
          
          .bar {
            flex: 1;
            background-color: #ff5a36;
            border-radius: 3px 3px 0 0;
            opacity: 0.7;
            
            &:nth-child(1) { height: 30%; }
            &:nth-child(2) { height: 45%; }
            &:nth-child(3) { height: 35%; }
            &:nth-child(4) { height: 60%; }
            &:nth-child(5) { height: 50%; }
            &:nth-child(6) { height: 80%; opacity: 1; }
          }
        }
      }
    }
  }

  .floating-box {
    position: absolute;
    background: $white;
    border-radius: 12px;
    padding: 0.7em 1.1em;
    display: flex;
    align-items: center;
    gap: 0.7em;
    box-shadow: 0 10px 25px rgba(0,0,0,0.08);
    font-size: 0.9em;
    font-weight: 600;
    color: $text-color;
    z-index: 10;
    white-space: nowrap;
    opacity: 1 !important;
    
    .icon-circle {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(#ff5a36, 0.1);
      flex-shrink: 0;
      
      svg {
        width: 18px;
        height: 18px;
        stroke: #ff5a36;
      }
    }

    &.floating-box-1 {
      top: 15%;
      left: -15%;
      
      @media screen and (max-width: 1200px) {
        left: -5%;
      }
      
      @media screen and (max-width: 992px) {
        top: 25%;
        left: -35%;
      }
    }
    
    &.floating-box-2 {
      top: 5%;
      right: -20%;
      
      @media screen and (max-width: 1200px) {
        right: -10%;
      }
      
      @media screen and (max-width: 992px) {
        top: 15%;
        right: -35%;
      }
    }
    
    &.floating-box-3 {
      bottom: 5%;
      right: -10%;
      
      @media screen and (max-width: 992px) {
        bottom: 15%;
        right: -25%;
      }
    }
    
    @media screen and (max-width: 768px) {
      display: none; // Hide absolute ones on mobile
    }
  }

  .floating-boxes-mobile {
    display: none;
    @media screen and (max-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 10px;
      margin-top: 35px;
      width: 100%;
      
      .floating-box { 
        position: relative;
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        display: flex;
        font-size: 0.85em;
        padding: 0.6em 1em;
      }
    }
  }

  .problem-content {
    flex: 1;
    
    @media screen and (max-width: 992px) {
      text-align: center;
      max-width: 800px;
      margin: 0 auto;
    }
    
    .pre-title {
      font-size: 0.85em;
      font-weight: 700;
      color: #94a3b8;
      letter-spacing: 1px;
      text-transform: uppercase;
      margin-bottom: 1em;
      display: block;
    }
    
    h2 {
      font-size: 2.4em;
      font-weight: 800;
      color: $text-color;
      line-height: 1.25;
      margin-bottom: 0.8em;
      
      .highlight-orange {
        color: #ff5a36;
      }
      
      @media screen and (max-width: 768px) {
        font-size: 1.9em;
      }
    }
    
    p {
      font-size: 1.05em;
      color: lighten($text-color, 15%);
      line-height: 1.6;
      margin-bottom: 1.2em;
      
      &.desc-1 {
        font-weight: 500;
        color: lighten($text-color, 5%);
      }
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.how-it-works {
  padding: 6em 0 3em 0;
  background-color: $white;
  
  @media screen and (max-width: 768px) {
    padding: 3em 0 2em 0;
  }

  .section-title {
    margin-bottom: 4em;
    
    .pre-title {
      font-size: 0.9em;
      font-weight: 700;
      color: $black;
      text-transform: uppercase;
      letter-spacing: 1px;
      display: block;
      margin-bottom: 0.8em;
    }
    
    h2 {
      font-size: 2.2em;
      font-weight: 700;
      color: $text-color;
    }
  }

  .cards-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5em;
    
    @media screen and (max-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .step-card {
    border: 1px solid darken($gray, 5%);
    border-radius: 1.5em;
    padding: 2.2em;
    background-color: $white;
    text-align: left;
    transition: box-shadow 0.3s ease;
    
    &:hover {
      box-shadow: 0 10px 30px rgba(0,0,0,0.05);
    }
    
    @media screen and (max-width: 768px) {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    
    .icon-box {
      width: 58px;
      height: 58px;
      background-color: $primary-color;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.8em;
      
      svg {
        width: 28px;
        height: 28px;
        stroke: $white;
      }
    }
    
    h3 {
      font-size: 1.25em;
      font-weight: 700;
      color: $text-color;
      margin-bottom: 0.8em;
      line-height: 1.3;
    }
    
    p {
      font-size: 0.95em;
      color: $black;
      line-height: 1.5;
      margin: 0;
    }
  }
}

.testimonials {
  padding: 5em 0;
  background-color: $white;

  .section-title {
    margin-bottom: 3.5em;
    
    h2 {
      font-size: 2.2em;
      font-weight: 700;
      color: $text-color;
      margin-bottom: 0.5em;
    }
    
    p {
      font-size: 1.15em;
      color: $black;
      max-width: 800px;
      margin: 0 auto;
    }
  }

  .testimonial-card {
    border: 1px solid darken($gray, 8%);
    border-radius: 2em;
    overflow: hidden;
    background-color: $white;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.03);
  }

  .testimonial-content {
    display: flex;
    align-items: stretch;
    min-height: 400px;

    @media screen and (max-width: 992px) {
      flex-direction: column-reverse;
    }
  }

  .text-area {
    flex: 1;
    padding: 4em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    
    @media screen and (max-width: 992px) {
      padding: 2.5em;
    }
    
    @media screen and (max-width: 768px) {
      padding: 1.5em;
    }

    h3 {
      font-size: 1.8em;
      font-weight: 700;
      color: $text-color;
      margin-bottom: 0.4em;
    }

    .highlight {
      font-size: 1.3em;
      font-weight: 600;
      color: $primary-color;
      margin-bottom: 1.2em;
      line-height: 1.4;
    }

    p {
      font-size: 1.05em;
      color: lighten($text-color, 10%);
      line-height: 1.6;
      margin: 0;

      strong {
        color: $text-color;
        font-weight: 700;
      }
    }
  }

  .video-area {
    flex: 1;
    background-color: $gray;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 350px;
    border-left: 1px solid darken($gray, 5%);
    overflow: hidden;
    
    @media screen and (max-width: 992px) {
      border-left: none;
      border-bottom: 1px solid darken($gray, 5%);
    }
    
    @media screen and (max-width: 768px) {
      min-height: 250px;
    }

    .testimonial-video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.cta-banner {
  padding: 4em 0;
  background-color: $white;
  
  .cta-banner-inner {
    background-color: #031435; // very dark blue
    border-radius: 1.5em;
    padding: 3em 3.5em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 3em;
    
    @media screen and (max-width: 1100px) {
      flex-direction: column;
      padding: 2.5em;
    }
  }
  
  .cta-left {
    flex: 1.2;
    
    h2 {
      color: #fff;
      font-size: 1.7em;
      font-weight: 700;
      line-height: 1.3;
      margin-bottom: 1em;
    }
    
    .features {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      gap: 1.5em;
      
      li {
        color: #94a3b8;
        font-size: 0.95em;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 0.5em;
        
        svg {
          width: 18px;
          height: 18px;
          stroke: #94a3b8;
        }
      }
      
      @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: 0.8em;
      }
    }
  }
  
  .cta-middle {
    flex: 1;
    display: flex;
    justify-content: center;
    
    .gift-badge-container {
      background-color: #172a5a;
      border-radius: 16px;
      padding: 1.5em 2.5em 1.5em 7em;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-width: 240px;
      
      .gift-illustration {
        position: absolute;
        left: -220px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 5;
      }
      
      .gift-img {
        width: 400px;
        height: auto;
        filter: drop-shadow(0 15px 35px rgba(0,0,0,0.5));
        transition: transform 0.3s ease;
        
        &:hover {
          transform: translateY(-5px) scale(1.05);
        }
      }
      
      .gift-text {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        z-index: 6;
        
        .amount {
          color: #fff;
          font-size: 2.1em;
          font-weight: 800;
          line-height: 1.1;
          letter-spacing: -0.5px;
        }
        
        .desc {
          color: #e2e8f0;
          font-size: 1.25em;
          font-weight: 500;
          margin-top: 0.2em;
        }
      }
      
      @media screen and (max-width: 768px) {
        padding: 6.5em 1.5em 1.5em 1.5em;
        margin-top: 5em;
        width: 100%;
        min-width: unset;
        
        .gift-illustration {
          left: 50%;
          top: -10px;
          transform: translateX(-50%) translateY(-50%);
          width: 100%;
          display: flex;
          justify-content: center;
        }
        
        .gift-img {
          width: 320px !important;
          max-width: none;
        }
        
        .gift-text .amount {
          font-size: 1.8em;
        }
        
        .gift-text .desc {
          font-size: 1.1em;
        }
      }
    }
  }
  
  .cta-right {
    flex: 1;
    width: 100%;
    
    h3 {
      color: #fff;
      font-size: 1.05em;
      font-weight: 600;
      margin-bottom: 1.2em;
    }
    
    .cta-form {
      display: flex;
      flex-direction: column;
      gap: 0.6em;
      
      .form-row {
        display: flex;
        gap: 0.6em;
        
        input {
          flex: 1;
        }
        
        @media screen and (max-width: 500px) {
          flex-direction: column;
        }
      }
      
      input {
        width: 100%;
        padding: 0.8em 1em;
        border-radius: 6px;
        border: none;
        background-color: #fff;
        font-size: 0.9em;
        color: #333;
        outline: none;
        
        &::placeholder {
          color: #94a3b8;
        }
        
        &:focus {
          box-shadow: 0 0 0 2px rgba(#ea580c, 0.5);
        }
        
        &.error {
          border: 2px solid red !important;
          background-color: #fffafa;
        }
      }
      
      .submit-btn {
        width: 100%;
        padding: 0.9em;
        background-color: #ea580c;
        color: #fff;
        border: none;
        border-radius: 6px;
        font-size: 0.95em;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5em;
        transition: background-color 0.2s;
        
        &:hover {
          background-color: darken(#ea580c, 5%);
        }
      }
    }
  }
}
</style>
